<template>
    <div></div>
</template>
<script>
    import Vue from 'vue';
    import { vuexOidcProcessSilentSignInCallback } from 'vuex-oidc';
    import { oidcSettings } from './config/oidc'


    export default {
        name: 'SilentRenew',
        methods: {

        },
        mounted() {
            vuexOidcProcessSilentSignInCallback(oidcSettings)
        }
    }

</script>
<style>

</style>
